import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const emailChannel = defineChannel({
  id: 'email',
  icon: 'email',
} as const satisfies ChannelDefinition);
